import React, { Component } from "react";
import style from "./style.scss";
import { StrokeIcon } from "../Icon";
import { connect } from "react-redux";
import { updateTheme } from "../../../redux/actions/navigationActions";

class VisionMode extends Component {
  state = {
    isNightMode: false,
  };

  UNSAFE_componentWillMount() {
    var mode = localStorage.getItem("visionMode");
    if (mode === "night") {
      document.body.classList.remove("light-mode");
      document.body.classList.add("night-mode");
      this.setState({
        isNightMode: true,
      });
    } else {
      document.body.classList.remove("night-mode");
      document.body.classList.add("light-mode");
      this.setState({
        isNightMode: false,
      });
    }
  }

  // COMPONENT Render ................................
  render() {
    return (
      <div
        className={style.visionMode}
        onClick={() => {
          var mode = localStorage.getItem("visionMode");
          if (mode === "night") {
            localStorage.setItem("visionMode", "light");
            document.body.classList.remove("night-mode");
            document.body.classList.add("light-mode");
            this.setState({
              isNightMode: false,
            });
            this.props.updateTheme(false)

          } else {
            localStorage.setItem("visionMode", "night");
            document.body.classList.remove("light-mode");
            document.body.classList.add("night-mode");

            this.setState({
              isNightMode: true,
            });
            this.props.updateTheme(true)
          }
        }}
      >
        <StrokeIcon icon={this.state.isNightMode ? "sun" : "moon"} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    theme: state.theme,
  };
}

export default connect(mapStateToProps, { updateTheme })(VisionMode);



// WEBPACK FOOTER //
// ./src/Components/Theme/VisionMode/index.js